<template>
  <div class="special_radio">
    <div class="title_h1">日程回答（工事）</div>
    <vab-collapse-info>
      <template slot="title">
        {{ getFieldValue('demandBaseIdModel.title', info) }}［{{
          getFieldValue(
            'requestIdModel.purchaseOrderBaseIdModel.acceptOrderKey',
            info
          )
        }}］
      </template>
      <template v-if="showDownLoad" slot="upload">
        <div
          class="flex_center_align"
          @click="
            downLoadInfomation(
              '/api/scheduleAdjAnswer/partner/estimate/download'
            )
          "
        >
          <span>見積情報ダウンロード</span>
          <svg-icon icon-class="download_2_line" class="upload_svg"></svg-icon>
        </div>
      </template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{ getFieldValue('buildingCdModel.blgsnmkj', info) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">商品</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'requestIdModel.purchaseOrderBaseIdModel.itemCdModel.itmcdModel.itmnm',
                info
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">商品明細</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'requestIdModel.purchaseOrderBaseIdModel.itemCdModel.itmdtlnm',
                info
              )
            }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">発注件名</vab-col>
          <vab-col :span="20" class="word_box noborderright">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{
                  getFieldValue(
                    'requestIdModel.purchaseOrderBaseIdModel.purchaseOrderName',
                    info
                  )
                }}
              </div>
              <div class="sub_title">
                (発注No：{{
                  getFieldValue(
                    'requestIdModel.purchaseOrderBaseIdModel.acceptOrderNo',
                    info
                  )
                }}）
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">案件分類</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue('demandBaseIdModel.businessForm', info),
                $divisions.consignmentWorkClassEnum
              )
            }}
          </vab-col>

          <vab-col :span="4" class="title_box">依頼区分</vab-col>
          <vab-col :span="8" class="word_box noborderright flex_center_align">
            {{
              getEnumText(
                getFieldValue('requestIdModel.requestClass', info),
                $divisions.requestClassEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">進行部門</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue('requestIdModel.requestDepCdModel.orgkjrn', info)
            }}
          </vab-col>
          <vab-col :span="4" class="title_box rline">進行担当者</vab-col>
          <vab-col :span="8" class="word_box noborderright center_box">
            <div
              v-for="(item, index) in getFieldValue(
                'requestIdModel.purchaseOrderBaseIdModel.purchaseOrderChargePersonModelList',
                info
              )"
              :key="index"
            >
              {{ getFieldValue('empnmkj', item.chargePersonCdModel) }}
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">日程調整状況</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                info.adjScheduleStatus,
                $divisions.adjScheduleStatusEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">書類提出期限</vab-col>
          <vab-col :span="8" class="word_box noborderright flex_center_align">
            {{ getFieldValue('requestIdModel.docLimitDate', info) }}
          </vab-col>
          <vab-col :span="4" class="title_box">排水制限</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getEnumText(
                getFieldValue(
                  'requestIdModel.purchaseOrderBaseIdModel.drainageLimit',
                  info
                ),
                $divisions.drainageLimitEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box rline">産廃処理区分</vab-col>
          <vab-col :span="8" class="word_box noborderright flex_center_align">
            {{
              getEnumText(
                getFieldValue(
                  'requestIdModel.purchaseOrderBaseIdModel.trashTreatDivision',
                  info
                ),
                $divisions.trashTreatDivisionEnum
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">納品予定年月</vab-col>
          <vab-col :span="20" class="word_box noborderright flex_center_align">
            {{
              getFomateMonth(
                getFieldValue('demandBaseIdModel.contractEndDate', info)
              )
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">発注コメント</vab-col>
          <vab-col :span="20" class="word_box flex_center_align">
            {{
              getFieldValue(
                'requestIdModel.purchaseOrderBaseIdModel.purchaseOrderComment',
                info
              )
            }}
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>

    <div class="info_main workInfo new_workInfo">
      <div class="head_box flex_start flex_center_align">
        <svg-icon icon-class="edit_2_line"></svg-icon>
        <span class="hd_title">日程調整</span>
      </div>
      <div class="h_date flex_center_align">
        <svg-icon icon-class="tryangle_down" class="h_svg"></svg-icon>
        <span class="h_title h_img_none">
          対応日程と詳細情報を登録してください
        </span>
        <span class="h_title h_img_none h_txt_red">
          ※
          工期設定が月末になりますと完了の検収に時間を要する場合がございます。ゆとりのある工期設定をお願いします。
        </span>
      </div>
      <vab-form ref="form" :model="form" :rules="rules">
        <div class="sure_box top_info mtn">
          <vab-row
            v-for="(row, index) in form.scheduleAdjDetailModelList"
            :key="index"
            class="row_box"
          >
            <vab-col :span="4" class="title_box">
              <div class="flex_colum">
                <div>対応日程{{ index + 1 }}</div>
                <div
                  class="clear_btn"
                  :class="
                    form.scheduleAdjDetailModelList.length == 1 ||
                    dealingDisable
                      ? 'disabledBtn '
                      : ''
                  "
                  @click="delSchedule(index, row)"
                >
                  削除
                </div>
              </div>
            </vab-col>
            <vab-col :span="20" class="word_box nopadding pdtb8">
              <vab-row class="flex_center_align margin_8">
                <vab-col class="flex_center_align picker_label">
                  <span class="tz_title">日程</span>
                </vab-col>
                <vab-col class="date_picker width_auto">
                  <div class="flex_start tz_right flex_center_align">
                    <vab-date-picker
                      type="date"
                      :label-show="false"
                      value-format="yyyy/MM/dd"
                      label-error="日程"
                      format="yyyy/MM/dd"
                      :validate="vaildateTimeStart(row, index)"
                      :prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                      :end-date-prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                      :clearable="false"
                      :disabled="dealingDisable"
                      @change="(value) => changeWattingDate(row, index, value)"
                    />
                    <div class="line">～</div>
                    <vab-date-picker
                      type="date"
                      :label-show="false"
                      value-format="yyyy/MM/dd"
                      label-error="日程"
                      format="yyyy/MM/dd"
                      :validate="vaildateTimeEnd(row, index)"
                      :prop="`scheduleAdjDetailModelList.${index}.endDateTime`"
                      :clearable="false"
                      :disabled="dealingDisable"
                      :start-date-prop="`scheduleAdjDetailModelList.${index}.startDateTime`"
                      @change="(value) => changeWattingDate(row, index, value)"
                    />
                  </div>
                </vab-col>
              </vab-row>
              <vab-row class="margin_8">
                <vab-col class="flex_center_align picker_label">
                  <span class="tz_title">時間</span>
                </vab-col>
                <vab-col class="time_picker">
                  <div class="flex_start flex_center_align">
                    <vab-time-picker
                      :prop="`scheduleAdjDetailModelList.${index}.startTime`"
                      format="HH:mm"
                      value-format="HH:mm"
                      :value-format-sss="true"
                      :disabled="row.disabled"
                      :end-date-prop="`scheduleAdjDetailModelList.${index}.endTime`"
                    ></vab-time-picker>

                    <div class="line">～</div>
                    <vab-time-picker
                      :prop="`scheduleAdjDetailModelList.${index}.endTime`"
                      format="HH:mm"
                      value-format="HH:mm"
                      :value-format-sss="true"
                      :disabled="row.disabled"
                      :start-date-prop="`scheduleAdjDetailModelList.${index}.startTime`"
                    ></vab-time-picker>
                    <div class="end_box">
                      <vab-checkbox
                        :ref="'dayFlag' + index"
                        label="終日"
                        :prop="`scheduleAdjDetailModelList.${index}.dayFlag`"
                        :code-enum="$divisions.validFlgEnum"
                        :disabled="row.checkDisabled"
                        :class="row.checkDisabled ? 'checkbox_disabled' : ''"
                        @change="(value) => changeDayFlag(value, row)"
                      ></vab-checkbox>
                    </div>
                  </div>
                </vab-col>
              </vab-row>
              <div class="line_boder margin_8"></div>
              <vab-row
                v-for="(item, s) in hbList"
                :key="s"
                class="margin_8 width_auto"
              >
                <vab-col class="flex_center_align picker_label">
                  <span class="tz_title">{{ item.name }}</span>
                </vab-col>
                <vab-col class="width_auto">
                  <div class="flex_start flex_center_align width_auto">
                    <div class="radio_box">
                      <vab-radio-group
                        :ref="item.prefix + index"
                        :prop="`scheduleAdjDetailModelList.${index}.${item.prefix}ExistFlag`"
                        :code-enum="$divisions.existFlag2Enum"
                        filter="existFlag2"
                        :disabled="dealingDisable"
                        class="margin_0"
                      />
                    </div>
                    <div class="flex_start flex_center_align time_picker_no">
                      <vab-time-picker
                        class="margin_0 work_time"
                        :prop="`scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`"
                        format="HH:mm"
                        value-format="HH:mm"
                        :value-format-sss="true"
                        :validate="validateStartTime(row, item, index)"
                        :end-date-prop="`scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`"
                        :disabled="
                          !checkEnumFlag(row[item.prefix + 'ExistFlag']) ||
                          dealingDisable
                        "
                      ></vab-time-picker>
                      <div class="line">～</div>
                      <vab-time-picker
                        class="margin_0"
                        :prop="`scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`"
                        format="HH:mm"
                        value-format="HH:mm"
                        :value-format-sss="true"
                        :validate="validateEndTime(row, item, index)"
                        :start-date-prop="`scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`"
                        :disabled="
                          !checkEnumFlag(row[item.prefix + 'ExistFlag']) ||
                          dealingDisable
                        "
                      ></vab-time-picker>
                    </div>
                  </div>
                </vab-col>
              </vab-row>
              <vab-row>
                <vab-col class="flex_center_align picker_label hei32">
                  <span class="tz_title">駐車利用</span>
                </vab-col>
                <vab-col class="width_auto">
                  <div class="flex_start flex_center_align width_auto hei32">
                    <div class="radio_box">
                      <vab-radio-group
                        :ref="'parkFlg' + index"
                        class="margin_0"
                        :prop="`scheduleAdjDetailModelList.${index}.parkFlg`"
                        :code-enum="$divisions.necessaryFlagEnum"
                        filter="existFlag2"
                        :disabled="dealingDisable"
                      />
                    </div>
                  </div>
                </vab-col>
              </vab-row>
            </vab-col>
          </vab-row>
          <vab-row v-if="!dealingDisable" class="add_btn_box">
            <div class="tzx_box">
              <span class="upload_btn_box" @click="addSchedule">
                対応日程追加
              </span>
            </div>
          </vab-row>
          <vab-collapse
            class="message_collapse"
            :title="'カレンダーを閉じる'"
            :dot="true"
          >
            <div class="los_box">
              <vab-calendar ref="calendar"></vab-calendar>
            </div>
          </vab-collapse>
          <div class="tableInfo changeInfo">
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">調整内容確認先</vab-col>
              <vab-col :span="20" class="word_box nopadding2 flex_center_align">
                <vab-checkbox
                  prop="localManagerAdjFlg"
                  :code-enum="$divisions.localAdjFlgEnum"
                  label="現地管理員"
                  :disabled="dealingDisable"
                ></vab-checkbox>
                <div style="width: 16px"></div>
                <vab-checkbox
                  prop="basePersonAdjFlg"
                  :code-enum="$divisions.localAdjFlgEnum"
                  class="mr16"
                  label="建物担当者"
                  :disabled="dealingDisable"
                ></vab-checkbox>
                <div style="width: 16px"></div>
                <vab-checkbox
                  prop="customerAdjFlg"
                  :code-enum="$divisions.localAdjFlgEnum"
                  class="mr16"
                  label="工事担当者"
                  :disabled="dealingDisable"
                ></vab-checkbox>
                <div style="width: 16px"></div>
                <vab-checkbox
                  prop="otherCheckbox"
                  :code-enum="$divisions.localAdjFlgEnum"
                  label="その他"
                  :checked="true"
                  :disabled="dealingDisable"
                  @change="otherCheckboxChange"
                ></vab-checkbox>
                <div style="width: 16px"></div>
                <vab-input
                  prop="otherAdjTxt"
                  maxlength="255"
                  :disabled="otherDisabled"
                ></vab-input>
              </vab-col>
              <vab-col :span="4" class="title_box">広報</vab-col>
              <vab-col :span="20" class="word_box nopadding2 pdtb8">
                <div class="flex_colum">
                  <vab-radio-group
                    prop="noticeFlg"
                    :code-enum="$divisions.existFlag2Enum"
                    class="mr16 in_mb20"
                    filter="existFlag2"
                    :disabled="dealingDisable"
                    @change="changeNoticeFlg"
                  />
                  <div class="flex_start">
                    <vab-checkbox
                      prop="localPostingFlg"
                      :code-enum="$divisions.necessaryFlagEnum"
                      label="掲示（現地に提示）"
                      :disabled="
                        dealingDisable ||
                        isEqualCodeEnum(
                          form.noticeFlg,
                          $divisions.existFlag2Enum.enum_blank
                        )
                      "
                    ></vab-checkbox>
                    <div style="width: 16px"></div>
                    <vab-checkbox
                      prop="managePostingFlg"
                      :code-enum="$divisions.necessaryFlagEnum"
                      label="掲示（管理室へFax）"
                      :disabled="
                        dealingDisable ||
                        isEqualCodeEnum(
                          form.noticeFlg,
                          $divisions.existFlag2Enum.enum_blank
                        )
                      "
                    ></vab-checkbox>
                    <div style="width: 16px"></div>
                    <vab-checkbox
                      prop="postingFlag"
                      :code-enum="$divisions.necessaryFlagEnum"
                      class="mr16"
                      label="ポスティング"
                      :disabled="
                        dealingDisable ||
                        isEqualCodeEnum(
                          form.noticeFlg,
                          $divisions.existFlag2Enum.enum_blank
                        )
                      "
                    ></vab-checkbox>
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">消防検査</vab-col>
              <vab-col :span="20" class="word_box nopadding2 flex_center_align">
                <vab-radio-group
                  prop="fireInspectionFlg"
                  :code-enum="$divisions.existFlag2Enum"
                  filter="existFlag2"
                  :disabled="dealingDisable"
                />
              </vab-col>
              <vab-col :span="4" class="title_box">消防署事前協議</vab-col>
              <vab-col :span="20" class="word_box nopadding2 flex_center_align">
                <div cclass="flex_colum">
                  <vab-radio-group
                    prop="fireConsultationFlg"
                    :code-enum="$divisions.fireConsultationFlgEnum"
                    filter="fireConsultationFlg"
                    :disabled="dealingDisable"
                  />
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">産廃処理担当者</vab-col>
              <vab-col :span="20" class="word_box nopadding2 flex_center_align">
                <div class="tz_right w140">
                  <vab-input
                    prop="constructionPersonName"
                    :disabled="dealingDisable"
                    maxlength="42"
                  ></vab-input>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">
                産廃処理担当者 電話番号
              </vab-col>
              <vab-col :span="20" class="word_box nopadding2 flex_center_align">
                <div class="tz_right w140">
                  <vab-input
                    v-input.num
                    prop="telNo"
                    :disabled="dealingDisable"
                    maxlength="18"
                  ></vab-input>
                </div>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col :span="4" class="title_box">産廃予想排出量</vab-col>
              <vab-col :span="20" class="word_box nopadding2 flex_center_align">
                <div class="tz_right w140">
                  <vab-input
                    v-input.float="3"
                    v-numberFormat.float="3"
                    class="percentInput"
                    prop="industryWasteAmount"
                    :disabled="dealingDisable"
                    validate="range:0|9999999.999"
                  >
                    <template #append>立米</template>
                  </vab-input>
                </div>
              </vab-col>
            </vab-row>
          </div>
        </div>

        <div class="sure_box top_info">
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">協力会社コメント</vab-col>
            <vab-col :span="20" class="word_box nopadding2 pdtb8">
              <vab-textarea
                type="textarea"
                prop="submitRemarks"
                rows="5"
                maxlength="1170"
              ></vab-textarea>
            </vab-col>
          </vab-row>
          <vab-message
            class="detail_nopadding"
            :msg-type="$divisions.adjSourceClassEnum.enum_1.value"
            :title="'コメント履歴を閉じる'"
            :msg-id="$route.query.requestDetailId"
          ></vab-message>
        </div>
      </vab-form>
      <div class="flex_end mg12">
        <vab-button :btn-list="btnList"></vab-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    scheduleAdjustmentInfoSC1,
    subumitScheduleSc1,
    completedScheduleSc1,
    scheduleList,
    calendarSc1,
    partnerSc1,
  } from '@/api/scheduleAdjustment'
  import mixinPage from '@/utils/mixinPage'
  import mixOperationType from '@/utils/mixOperationType'
  import mixinSchedule from '@/utils/mixinSchedule'
  export default {
    name: 'PWS02G03',
    mixins: [mixinPage, mixOperationType, mixinSchedule],
    provide() {
      return {
        formData: () => this.form,
        setDrawTimeList: this.setDrawTimeList,
        setInfoDateList: this.setInfoDateList,
        vmData: this,
      }
    },
    data() {
      return {
        delList: [],
        form: {
          scheduleAdjId: null,
          scheduleAdjDetailModelList: [],
          otherCheckbox: null,
        },
        rules: {},
        info: {
          buildingCdModel: {},
          itemCdModel: {},
          purchaseOrderDepCdModel: {},
          progressPersonCdModel: {},
        },
        hbList: [
          {
            name: '断水時間',
            prefix: 'waterOff',
          },
          {
            name: '停電時間',
            prefix: 'electricOff',
          },
          {
            name: '回収希望時間',
            prefix: 'collection',
          },
        ],
        btnList: [],
        dealingDisable: false,
        needToConfirm: false,
        initTableList: [],
      }
    },
    computed: {
      otherDisabled() {
        return (
          this.dealingDisable ||
          !this.isEqualCodeEnum(
            this.form.otherCheckbox,
            this.$divisions.localAdjFlgEnum.enum_1
          )
        )
      },
      validateStartTime() {
        return (row, item, index) => {
          if (this.checkEnumFlag(row[item.prefix + 'ExistFlag'])) {
            if (this.$baseLodash.isEmpty(row[item.prefix + 'StartTime'])) {
              this.$set(
                this.rules,
                `scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`,
                [
                  {
                    required: true,
                    message: this.format(
                      this.$t(
                        `validateMessage.${this.$messageCode.E00000001.name}`
                      ),
                      '時間'
                    ),
                    trigger: 'blur',
                  },
                ]
              )
            } else {
              this.$set(
                this.rules,
                `scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`,
                [
                  {
                    required: false,
                    message: null,
                  },
                ]
              )
              this.$refs.form.clearValidate([
                `scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`,
              ])
            }
          } else {
            this.$refs.form.clearValidate([
              `scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`,
            ])
            this.$set(
              this.rules,
              `scheduleAdjDetailModelList.${index}.${item.prefix}StartTime`,
              [
                {
                  required: false,
                  message: null,
                },
              ]
            )
            row[`${item.prefix}StartTime`] = null
          }
        }
      },
      validateEndTime() {
        return (row, item, index) => {
          if (this.checkEnumFlag(row[item.prefix + 'ExistFlag'])) {
            if (this.$baseLodash.isEmpty(row[item.prefix + 'EndTime'])) {
              this.$set(
                this.rules,
                `scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`,
                [
                  {
                    required: true,
                    message: this.format(
                      this.$t(
                        `validateMessage.${this.$messageCode.E00000001.name}`
                      ),
                      '時間'
                    ),
                    trigger: 'blur',
                  },
                ]
              )
            } else {
              this.$set(
                this.rules,
                `scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`,
                [
                  {
                    required: false,
                    message: null,
                  },
                ]
              )
              this.$refs.form.clearValidate([
                `scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`,
              ])
            }
          } else {
            this.$refs.form.clearValidate([
              `scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`,
            ])
            this.$set(
              this.rules,
              `scheduleAdjDetailModelList.${index}.${item.prefix}EndTime`,
              [
                {
                  required: false,
                  message: null,
                },
              ]
            )
            row[`${item.prefix}EndTime`] = null
          }
        }
      },
      enAdjScheduleStatus4() {
        return this.isEqualCodeEnum(
          this.getFieldValue('adjScheduleStatus', this.info),
          this.$divisions.adjScheduleStatusEnum.enum_4
        )
      },
    },
    mounted() {
      this.initData()
    },
    methods: {
      async initData() {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          // 依頼詳細ｉｄ
          let requestDetailId = this.$route.query?.requestDetailId
          // 依頼詳細ｉｄ
          if (requestDetailId) {
            // 工事日程回答(SC1)-日程調整依頼詳細情報
            await this.scheduleAdjustmentInfoSC1(requestDetailId)
            // 工事日程回答(SC1)-工事日程情報
            await this.getPartnerSc1(requestDetailId)
          }
        } finally {
          loadingInstance.close()
        }
      },
      // radio デフォルト値です
      setData(index) {
        this.$nextTick(() => {
          this.hbList.filter((hbItem) => {
            setTimeout(() => {
              this.$refs[hbItem.prefix + index][0].setValue(
                this.$divisions.existFlagEnum.enum_blank.value
              )
              this.$refs['parkFlg' + index][0].setValue(
                this.$divisions.necessaryFlagEnum.enum_blank.value
              )
            }, 0)
          })
        })
      },
      // チェック時間です
      validatorStartTime(rule, value, callback, row, item, type) {
        value = row[item.prefix + type]
        if (
          this.checkEnumFlag(row[item.prefix + 'ExistFlag']) &&
          this.$baseLodash.isEmpty(value)
        ) {
          callback(
            new Error(
              this.format(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`),
                '時間'
              )
            )
          )
        } else {
          callback()
        }
      },
      // 回答
      submitForm(row) {
        this.$refs['form'].validate((valid, obj) => {
          if (valid) {
            this.subumitScheduleSc1(row)
          } else {
            var a = []
            for (let key in obj) {
              a.push(obj[key][0].message)
            }
            this.$message({
              message: a[0],
              type: 'error',
            })
            return false
          }
        })
      },
      // 工事日程回答(SC1)
      async subumitScheduleSc1(row) {
        if (
          !this.form.scheduleAdjDetailModelList.some(
            (item) => item.startDateTime && item.endDateTime
          )
        ) {
          this.msgError(
            this.format(
              this.$t(`validateMessage.${this.$messageCode.I00000441.name}`)
            )
          )
          return
        }
        let submitData = {
          scheduleAdjId: this.getFieldValue(
            'scheduleAdjustmentModelList[0].scheduleAdjId',
            this.info
          ),
          requestDetailId: this.$route.query?.requestDetailId,
          worksUnavailableDayOutModelList: this.$refs.calendar.noDayList,
          needToConfirm: this.getNeedConfirm(
            this.$baseLodash.cloneDeep(this.form.scheduleAdjDetailModelList)
          ),
        }
        let info = JSON.parse(JSON.stringify(this.info))
        submitData.requestDetailIdModel = {
          ...info,
        }
        submitData.scheduleAdjDetailModelList =
          this.getScheduleAdjDetailModelList(
            this.form.scheduleAdjDetailModelList
          )
        submitData.submitRemarks = this.form.submitRemarks
        submitData.scheduleAdjSc1ModelList = [{ ...this.form }]
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await subumitScheduleSc1(submitData)
          if (
            this.isEqualCodeEnum(
              res?.requestDetailIdModel?.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_4
            )
          ) {
            await completedScheduleSc1(res)
          }
          this.msgSuccess(row.word)
          this.$closePage(this.$route.path)
          this.$routerPushAndReload({
            path: '/pws/PWS02G01',
            refresh: 'PWS02G01',
          })
        } finally {
          loadingInstance.close()
        }
      },
      //時間を選択する
      changeWattingDate(row, index, value) {
        // 日程が25日以降（25日含む）を選択の場合、アラートする
        // '後続業務に影響があるため、25日以降の日程を避けて頂きたいです。'
        // 3 25日以降（工事日程）
        if (this.$baseLodash.isEmpty(value)) {
          row.disabled = true
          row.checkDisabled = true
          row.dayFlag = null
          this.form.scheduleAdjDetailModelList[index].startTime = null
          this.form.scheduleAdjDetailModelList[index].endTime = null
          this.setDrawTimeList(this.form.scheduleAdjDetailModelList)
          return
        }
        if (this.$baseLodash.isEmpty(row.startDateTime)) {
          row.startDateTime = value
        }
        if (this.$baseLodash.isEmpty(row.endDateTime)) {
          row.endDateTime = value
        }
        let repeat = this.checkRepeatDate(
          row,
          index,
          this.form.scheduleAdjDetailModelList
        )
        if (repeat) return

        // let checkDay = this.$dayjs(value).format('DD')
        // if (checkDay >= 25) {
        //   this.msgInfo(
        //     this.$t(`validateMessage.${this.$messageCode.W00000113.name}`)
        //   )
        // }
        // 4 納品月がずれる（工事日程）
        // 要望「工事予定連絡書確認(DLN)画面について協力会社が入力した日程を、メールでまずは受領できるようにし、重複する場合や納品月がずれる場合にアラートもらうような機能にしてほしい」から
        // 判断基準：「予定日程の最終日」が「納品月」を超える場合
        // 例えば：「納品月」が7月し、「予定日程の最終日」が8月1日以降（含む）
        let contractEndDate = this.getFieldValue(
          'demandBaseIdModel.contractEndDate',
          this.info
        )
        if (
          !this.$baseLodash.isEmpty(contractEndDate) &&
          !this.$baseLodash.isEmpty(value) &&
          this.$dayjs(value).isAfter(this.$dayjs(contractEndDate))
        ) {
          this.msgInfo(
            this.$t(`validateMessage.${this.$messageCode.W00000218.name}`)
          )
        }
        // 2 重複する（事前調査と工事日程） #3175
        //  「SC1」の場合、デフォルト "4":調整済
        // でも、不可日または他の日程と重なるの時、"2":提出済（確認必要）
        // 以外の場合、"2":提出済
        // 「SC3」事前調査の場合、不可日を選択不可
        // if (
        //   this.isEqualCodeEnum(
        //     this.getFieldValue('demandType', this.info),
        //     this.$divisions.demandTypeEnum.enum_1
        //   ) ||
        //   this.isEqualCodeEnum(
        //     this.getFieldValue('demandType', this.info),
        //     this.$divisions.demandTypeEnum.enum_6
        //   )
        // ) {
        //   let isSame = false
        //   let noDayList = this.$refs.calendar.noDayList
        //   noDayList.filter((item) => {
        //     if (!isSame) {
        //       if (this.$dayjs(item.date).isSame(value, 'day')) {
        //         isSame = true
        //       }
        //     }
        //   })
        //   if (isSame) {
        //     temp3 = true
        //   } else {
        //     temp3 = false
        //   }
        // } else {
        //   temp3 = false
        // }

        //「SC1」工事・作業、不可日を選択提醒
        if (
          (this.isEqualCodeEnum(
            this.getFieldValue('demandType', this.info),
            this.$divisions.demandTypeEnum.enum_1
          ) ||
            this.isEqualCodeEnum(
              this.getFieldValue('demandType', this.info),
              this.$divisions.demandTypeEnum.enum_6
            )) &&
          this.isEqualCodeEnum(
            this.getFieldValue('requestIdModel.requestClass', this.info),
            this.$divisions.requestClassEnum.enum_2
          )
        ) {
          // let noDayList = this.$refs.calendar.noDayList
          // if (
          //   noDayList.some((time) =>
          //     this.$dayjs(time.date).isSame(value, 'day')
          //   )
          // ) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000286.name}`)
          //   )
          // }
          // if (this.checkCalendar(value, this.$refs.calendar.calendarList)) {
          //   this.msgInfo(
          //     this.$t(`validateMessage.${this.$messageCode.W00000217.name}`)
          //   )
          //   temp4 = true
          // }
          this.checkDayReportRequest(row)
        }
        if (
          !this.$baseLodash.isEmpty(row.startDateTime) &&
          !this.$baseLodash.isEmpty(row.endDateTime)
        ) {
          let isSame = this.$dayjs(row.startDateTime).isSame(
            row.endDateTime,
            'day'
          )
          if (!isSame) {
            row.disabled = true
            row.startTime = null
            row.endTime = null
            row.checkDisabled = true
            // 終日値は空です
            if (this.checkEnumFlag(row.dayFlag)) {
              row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
            }
          } else {
            row.disabled = false
            row.checkDisabled = false
            row.dayFlag = this.$divisions.validFlgEnum.enum_0.value
          }
          this.setDrawTimeList(this.form.scheduleAdjDetailModelList)
        }
      },
      setInfoDateList(list, formate = false) {
        if (list && list.length == 0) return
        if (!formate) {
          const keyList = [
            'collectionStartTime',
            'collectionEndTime',
            'electricOffStartTime',
            'electricOffEndTime',
            'waterOffStartTime',
            'waterOffEndTime',
          ]
          this.initTableList = this.$baseLodash.cloneDeep(list)
          this.initTableList.forEach((item) => {
            keyList.forEach((key) => {
              if (!this.$baseLodash.isNull(item[key])) {
                item[key] = this.formatTimeDefault(
                  item[key],
                  this.$const.dateFormatHHMMSSSSS
                )
              }
            })
          })
        }
        const getValue = (time) => {
          if (!time) {
            return this.$divisions.existFlagEnum.enum_blank.value
          }
          return this.$divisions.existFlagEnum.enum_1.value
        }
        list.filter((row, index) => {
          row.waterOffExistFlag = getValue(row.waterOffStartTime)
          row.electricOffExistFlag = getValue(row.electricOffStartTime)
          row.collectionExistFlag = getValue(row.collectionStartTime)
          if (
            !this.$baseLodash.isEmpty(row.startDateTime) &&
            !this.$baseLodash.isEmpty(row.endDateTime)
          ) {
            let isSame = this.$dayjs(row.startDateTime).isSame(
              row.endDateTime,
              'day'
            )
            if (!isSame) {
              row.disabled = true
              row.checkDisabled = true
            } else {
              row.disabled = false
              row.checkDisabled = false
            }
          }
          if (!formate) {
            row.startTime = this.$dayjs(row.startDateTime).format('HH:mm')
            row.endTime = this.$dayjs(row.endDateTime).format('HH:mm')
          } else {
            if (this.checkEnumFlag(row.dayFlag)) {
              row.disabled = true
            }
          }
          row.operationType = this.$divisions.operationTypeEnum.enum_U.value
          this.setCheckBoxValueDefault(row, index)
        })
        this.form.scheduleAdjDetailModelList = list
        this.setDisabledScheduleList(this.form.scheduleAdjDetailModelList)
      },
      setCheckBoxValueDefault(row, index) {
        setTimeout(() => {
          if (this.$refs['waterOff' + index]) {
            this.$refs['waterOff' + index][0].setValue(row.waterOffExistFlag)
          }
          if (this.$refs['electricOff' + index]) {
            this.$refs['electricOff' + index][0].setValue(
              row.electricOffExistFlag
            )
          }
          if (this.$refs['collection' + index]) {
            this.$refs['collection' + index][0].setValue(
              row.collectionExistFlag
            )
          }
          if (this.$refs['parkFlg' + index]) {
            this.$refs['parkFlg' + index][0].setValue(row.parkFlg)
          }
          if (this.$refs['dayFlag' + index]) {
            this.$refs['dayFlag' + index][0].setValue(row.dayFlag)
          }
        }, 0)
      },
      // 調整済み 無効化
      setDisabledScheduleList(list) {
        if (
          this.isEqualCodeEnum(
            this.info.adjScheduleStatus,
            this.$divisions.adjScheduleStatusEnum.enum_4
          )
        ) {
          list.filter((item) => {
            item.disabled = true
            item.checkDisabled = true
            item.timeDisabled = true
            this.$set(item, 'timeDisabled', true)
          })
          this.dealingDisable = true
        }
      },
      // カレンダーに時間を表示します
      setDrawTimeList(list) {
        if (list && list.length == 0) return
        let hbList = []
        list.filter((row, index) => {
          let data = {
            start: this.$dayjs(row.startDateTime).format(
              this.$const.dateFormatYYYYMMDD
            ),
            end: this.$dayjs(row.endDateTime).format(
              this.$const.dateFormatYYYYMMDD
            ),
            color: this.enAdjScheduleStatus4 ? '#fff' : '#FA7830',
            icon: this.enAdjScheduleStatus4
              ? 'check_circle_fill'
              : 'check_circle_line',
            bg: this.enAdjScheduleStatus4
              ? 'rgba(250, 120, 48, 0.9)'
              : 'rgba(250, 120, 48, 0.06)',
            title: '対応日程' + (index + 1),
            type: this.enAdjScheduleStatus4
              ? 'dyhope'
              : 'watting' + (index + 1),
          }
          hbList.push(data)
        })
        this.$nextTick(() => {
          this.$refs.calendar.clearFillForm([...hbList, ...this.hopeList])
        })
      },
      // 終日
      changeDayFlag(val, row) {
        if (val === this.$divisions.validFlgEnum.enum_1.value) {
          row.disabled = true
          row.startTime = null
          row.endTime = null
        } else {
          row.disabled = false
        }
      },
      // 工事日程回答(SC1)-日程調整依頼詳細情報
      async scheduleAdjustmentInfoSC1(requestDetailId) {
        const res = await scheduleAdjustmentInfoSC1(requestDetailId)
        this.info = res
        this.setBtnList()
        // 希望開始日・終了日
        this.hopeList = this.changeHopeDateList(
          this.getFieldValue('requestIdModel.expectStartDate', res),
          this.getFieldValue('requestIdModel.expectEndDate', res)
        )
        this.setGoodsInfoList(this.info)
        // 日程調整状況は「"1":未提出」以外の場合、工事日程情報を取得する。
        if (res.adjScheduleStatus) {
          if (
            !this.isEqualCodeEnum(
              res.adjScheduleStatus,
              this.$divisions.adjScheduleStatusEnum.enum_1
            )
          ) {
            // 工事日程回答(SC1)-対応日程
            await this.scheduleList(requestDetailId)
          } else {
            this.addSchedule()
            this.hopeDateListFill(
              this.getFieldValue('requestIdModel.expectStartDate', this.info),
              this.getFieldValue('requestIdModel.expectEndDate', this.info)
            )
          }
        }
        // 日程回答-カレンダー
        this.getCalendarList({
          requestYearMonth: this.getRequestYearMonth(
            this.form.scheduleAdjDetailModelList
          ),
        })
      },
      // 工事日程回答(SC1)-日程調整依頼詳細情報
      async getPartnerSc1(requestDetailId) {
        const res = await partnerSc1(requestDetailId)
        if (res) {
          Object.keys(this.form).filter((key) => {
            if (key != 'scheduleAdjDetailModelList') {
              this.$set(this.form, key, res[key])
            }
          })
          if (res?.otherAdjTxt) {
            this.form.otherCheckbox =
              this.$divisions.localAdjFlgEnum.enum_1.value
            this.setOtherRules(this.form.otherCheckbox)
          }
          this.form.scheduleAdjSc1Id = res?.scheduleAdjSc1Id
        }
      },
      // 日程回答-カレンダー
      async getCalendarList(info) {
        let data = {
          buildingCd: this.getFieldValue(
            'demandBaseIdModel.buildingCd',
            this.info
          ),
          sectionCd: this.getFieldValue(
            'demandBaseIdModel.sectionCd',
            this.info
          ),
          excludeRequestDetailId: this.info.requestDetailId,
          requestYearMonth: info.requestYearMonth,
        }
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await calendarSc1(data)
          if (res?.length && res.length > 0) {
            this.$refs.calendar.getTimes(info.requestYearMonth).then(() => {
              this.$refs.calendar.setPageData(data)
              this.$refs.calendar.setCalenderTime(res, this)
            })
          }
        } finally {
          loadingInstance.close()
        }
      },
      // 工事日程回答(SC1)-工事日程情報
      async scheduleList(requestDetailId) {
        let res = await scheduleList(requestDetailId)
        if (res?.length && res.length > 0) {
          this.setInfoDateList(this.$baseLodash.cloneDeep(res))
          this.setDrawTimeList(this.$baseLodash.cloneDeep(res))
        } else {
          this.addSchedule()
          this.hopeDateListFill(
            this.getFieldValue('requestIdModel.expectStartDate', this.info),
            this.getFieldValue('requestIdModel.expectEndDate', this.info)
          )
        }
      },
      // 候補スケジュール選択をクリアする
      delSchedule(index, item) {
        if (
          this.form.scheduleAdjDetailModelList.length == 1 ||
          this.dealingDisable
        ) {
          return
        }
        if (item?.scheduleAdjDetailId) {
          item.operationType = this.$divisions.operationTypeEnum.enum_D.value
          this.delList.push(this.$baseLodash.cloneDeep(item))
        }
        this.form.scheduleAdjDetailModelList.splice(index, 1)
        this.setDrawTimeList(this.form.scheduleAdjDetailModelList)
      },
      // 対応日程追加
      addSchedule() {
        let data = {
          startDateTime: null,
          endDateTime: null,
          /*  断水時間s*/
          waterOffStartTime: null,
          waterOffEndTime: null,
          /* 停電時間 */
          electricOffStartTime: null,
          electricOffEndTime: null,
          /*  回収希望時間 */
          collectionStartTime: null,
          collectionEndTime: null,
          dayFlag: 0, // 終日
          parkFlg: this.$divisions.existFlagEnum.enum_blank.value, //駐車利用
          waterOffExistFlag: this.$divisions.existFlagEnum.enum_blank.value,
          electricOffExistFlag: this.$divisions.existFlagEnum.enum_blank.value,
          collectionExistFlag: this.$divisions.existFlagEnum.enum_blank.value,
          disabled: true,
          checkDisabled: true,
          startTime: null,
          endTime: null,
          operationType: this.$divisions.operationTypeEnum.enum_I.value,
        }
        this.form.scheduleAdjDetailModelList.push(data)
        this.setData(this.form.scheduleAdjDetailModelList.length - 1)
      },
      // ボタンのテキストを動的に表示
      setBtnList() {
        this.btnList = [
          {
            name: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_2
                )
              ) {
                return '再回答'
              } else {
                return '回答'
              }
            })(),
            icon: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_2
                )
              ) {
                return 'answer2'
              } else {
                return 'answer'
              }
            })(),
            msg: this.$t(`validateMessage.${this.$messageCode.I00000449.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000450.name}`
            ),
            type: 'button',
            hidden: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_4
                )
              ) {
                return true
              } else {
                return false
              }
            })(),
            click: (row) => {
              this.submitForm(row)
            },
          },
          {
            name: '再提出依頼',
            icon: 'answer2',
            msg: this.format(
              this.$t(`validateMessage.${this.$messageCode.I00000191.name}`),
              '再提出依頼'
            ),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000444.name}`
            ),
            type: 'button',
            bg: '#C90022',
            hover: '#E12432',
            hidden: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('adjScheduleStatus', this.info),
                  this.$divisions.adjScheduleStatusEnum.enum_4
                )
              ) {
                return false
              } else {
                return true
              }
            })(),
            click: (row) => {
              this.submitForm(row)
            },
          },
        ]
      },
      otherCheckboxChange(val) {
        this.setOtherRules(val)
        if (this.isEqualCodeEnum(val, this.$divisions.localAdjFlgEnum.enum_0)) {
          this.form.otherAdjTxt = null
        }
      },
      // その他 rules
      setOtherRules(val) {
        this.$delete(this.rules, 'otherAdjTxt')
        this.$refs.form.clearValidate(['otherAdjTxt'])
        if (this.isEqualCodeEnum(val, this.$divisions.localAdjFlgEnum.enum_1)) {
          this.$set(this.rules, `otherAdjTxt`, [
            {
              required: true,
              message: this.format(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`),
                'その他の内容'
              ),
              trigger: ['blur', 'change'],
            },
          ])
        }
      },
    },
  }
</script>
<style scoped>
  .percentInput /deep/ .el-input-group__append {
    padding: 0 5px;
    background: none;
    border: none;
  }
</style>
<style lang="scss" scoped>
  .tableInfo {
    overflow: hidden;
    border: 1px solid #d1dae1;
    border-radius: $base-border-radius3;
    &.changeInfo {
      border: none;
      border-top: 1px solid #d1dae1;
      border-radius: 0;
    }
    &.m5 {
      margin-top: 5px;
      border-top: none;
    }
    .ts_box {
      padding: 10px 12px;
      background: #fff;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #003350;
      }
      .up_box {
        .upload_title {
          display: inline-block;
          padding-right: 30px;
          font-size: 14px;
          font-weight: 500;
          color: #004c82;
          text-decoration-line: underline;
          background: url('~@/assets/images/rcqr_1.png') right center no-repeat;
        }
        .arrow_img {
          width: 24px;
          height: 24px;
          margin-left: 40px;
        }
      }
    }
  }
  .add_btn_box {
    border-bottom: 1px solid #d1dae1;
    .upload_btn_box {
      margin-bottom: 10px;
      margin-left: 12px;
    }
  }

  .work_time {
    ::v-deep .el-form-item__content {
      text-align: center;
      width: 60px;
    }
  }
</style>
